import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Bitcoin, TrendingUp, Coins, LineChart } from 'lucide-react';

const Crypto = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #f7931a, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Cryptocurrency Hub
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            Real-time crypto tracking, portfolio management, and blockchain intelligence
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(247, 147, 26, 0.1)',
            border: '1px solid rgba(247, 147, 26, 0.3)'
          }}>
            <Bitcoin size={32} style={{ color: '#f7931a', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Price Tracker</h3>
            <p style={{ color: '#888' }}>Live cryptocurrency prices and charts</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <Coins size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Portfolio Manager</h3>
            <p style={{ color: '#888' }}>Track your crypto holdings</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)'
          }}>
            <LineChart size={32} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Market Analysis</h3>
            <p style={{ color: '#888' }}>AI-powered crypto insights</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(247, 147, 26, 0.3)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#f7931a', marginBottom: '1.5rem' }}>Crypto Widgets</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Comprehensive cryptocurrency tools:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Real-Time Price Tracker (BTC, ETH, and 100+ coins)</li>
              <li>Crypto Portfolio Manager</li>
              <li>Historical Charts & Technical Analysis</li>
              <li>Market Cap Rankings</li>
              <li>News & Sentiment Analysis</li>
              <li>Wallet Connection (Coming Soon)</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(247,147,26,0.1), rgba(0,255,136,0.1))',
          border: '2px solid #f7931a'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <TrendingUp size={32} style={{ color: '#f7931a' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#f7931a' }}>Crypto AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get expert cryptocurrency guidance from AI blockchain analysts. Ask about market trends, 
            investment strategies, technical analysis, or any crypto-related question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #f7931a, #00ff88)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Crypto AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Crypto;